import React, { useEffect, useRef, useState } from "react";
import { Typography,  Backdrop, CircularProgress, Button } from '@material-ui/core'
import * as Yup from "yup";
import _ from "lodash";
import { makeStyles } from '@material-ui/core/styles'
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import CropFreeIcon from '@material-ui/icons/CropFree';
import SnackBar from "components/SnackBar";
import ContainerHeader from "components/ContainerHeader";
import CardBox from "components/CardBox";
import Canvas from "components/Canvas"
import EZForm from "components/EZForm";
import ToolTipIcon from 'components/ToolTipIcon';
import API from "util/Api";
import APIV3 from "util/V3Api";
import SlotBookings from "./slotBookings";

const useStyles = makeStyles((theme) => (
    {
        label: {
            color: theme.palette.primary.main,
            marginTop: '16px'
        },
        appBar: {
            position: 'relative',
        },
        title: {
            marginLeft: theme.spacing(2),
            flex: 1,
        },
        headerStyle: {
            textAlign: 'end',
            marginBottom: 0
        },
        terminal: {
            background: '#263647',
            boxShadow: 'inset 0px 0px 5px black',
        },
        terminalText: {
            color: '#fff'
        },
        cardStyle: {
            padding: 0
        },
        preTag: {
            padding: 10,
            marginBottom: 0,
            width: '100%',
            margin: '0px !important'
        },
        btnOlder: {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            margin: 5,
            borderRadius: 25,
            fontSize: 10,
            marginTop: '-16px'
        }
    }
))

const ParkingSlotMap = (props) => {
    const handle = useFullScreenHandle()
    const classes = useStyles()
    const [fields, setFields] = useState();
    const [floor, setFloor] = useState();
    const [scale, setScale] = useState(1);
    const [fullScreen, setFullScreen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState();
    const [open, setOpen] = useState(false);
    const [streamUrl, setStreamUrl] = useState();
    const [selectedSlot, setSelectedSlot] = useState();
    const timeoutRef = useRef(null);
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    const validations = Yup.object().shape({
        location: Yup.object().required("Required"),
    });

    const handleSubmit = (data, { setSubmitting }) => {
        setFloor(undefined);
        API.post("parkingFloorMapSlotDetails", JSON.stringify(data))
            .then((res) => {
                setFloor(res.data.data);
                setSubmitting(false);
                setFormData(data);
            })
            .catch((err) => {
                setSubmitting(false);
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ?? "Something went wrong",
                    type: "error",
                });
            });
    };

    const handleChange = (formik) => {
        // console.log(' WhyRerendering___');
            const config = _.cloneDeep(fields);

        console.log('handleChange_____', formik.values.location);
        console.log('handleChange_____ Options', config.location.options);
        const values = formik.values;
        if (values.location && !_.isEqual(values.location.floors, fields.floor.options)) {
            formik.setFieldValue('floor_id', '');
            const config = _.cloneDeep(fields);
            config.floor.options = values.location.floors;
            setFields(config);
        }
    }

    useEffect(() => {
        API.get("parkingFloorMap")
            .then((res) => {
                setFields(res.data.data.fields);
            })
            .catch((err) => {
                console.error("error", err);
            });
    }, []);

    useEffect(() => {
        if (formData) {
            const intervalId = setInterval(() => {
                API.post("parkingFloorMapSlotDetails", JSON.stringify(formData))
                    .then((res) => {
                        setFloor(res.data.data);
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }, 60000); // refresh every 1 minut

            return () => clearInterval(intervalId);
        }
    }, [formData])
    
    const getCameraFeed = async (cameraData) => {
        try {
          setSelectedSlot(cameraData);
          setLoading(true);
      
          // Step 1: Send stream command
          await APIV3.post("streamCommand", JSON.stringify({
            camera_id: cameraData?.details?.camera_id,
            mac_address: cameraData?.details?.controller_mac
          }));
      
          // Step 2: Schedule stream URL fetch
          timeoutRef.current = setTimeout(async () => {
            try {
              const response2 = await APIV3.get(
                `streamUrl?camera_id=${cameraData?.details?.camera_id}&mac_address=${cameraData?.details?.controller_mac}`
              );
      
              console.log("Stream URL fetched:", response2?.data?.data);
              setStreamUrl(response2?.data?.data);
              setLoading(false);
              setOpen(true);
            } catch (error) {
              setLoading(false);
              setSnackBar({
                open: true,
                message: error?.response?.data?.msg ?? "Failed to fetch stream URL",
                type: "error",
              });
            }
          }, 20000);
      
        } catch (err) {
          setLoading(false);
          setSnackBar({
            open: true,
            message: err?.response?.data?.msg ?? "Failed to initiate stream command",
            type: "error",
          });
        }
      };
    const initiateMarkings = async ()=>{
        await APIV3.post("initiateMarkSlots", {camera_id: selectedSlot?.details?.camera_id ,mac_address: selectedSlot?.details?.controller_mac})
        .then((res) => {
        }).catch((err) => {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg ?? "Something went wrong",
                type: "error",
            });
        });
    }
    const completeMarkings = async (coordinates)=>{
        await APIV3.post("completeMarkSlots", {camera_id: selectedSlot?.details?.camera_id ,mac_address: selectedSlot?.details?.controller_mac, slots:coordinates})
        .then((res) => {
        }).catch((err) => {
            setSnackBar({
                open: true,
                message: err?.response?.data?.msg ?? "Something went wrong",
                type: "error",
            });
        });
    }
    return (
        <>
            {loading && (
            <Backdrop open={true} style={{ zIndex: 1301, color: '#fff' }}>
                <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <CircularProgress color="primary" />
                    <Button
                        variant="contained"  color="primary"
                        style={{marginTop: '20px'}}
                        onClick={() => {
                            if (timeoutRef.current) {
                            clearTimeout(timeoutRef.current);
                            timeoutRef.current = null;
                            setLoading(false); // Optional: stop loader
                            setSnackBar({
                                open: true,
                                message: "Stream request cancelled.",
                                type: "warning",
                            });
                            }
                        }}
                        >
                        Stop Stream
                    </Button>
                </div>
            </Backdrop>
            )}
            <ContainerHeader title={`Parking Slots Map`} match={props.match} />
            {fields && <EZForm
                fields={Object.values(fields)}
                validationSchema={validations}
                handleChange={handleChange}
                onSubmit={handleSubmit}
            />}

            <div className="row" style={{ display: floor ? 'block' : 'none' }}>
                <CardBox styleName="col-12" headingStyle={classes.headerStyle} heading={
                    <>
                        <Typography style={{ float: 'left', textAlign: 'left' }} variant={'h6'} component={'h6'}>Parking Map - {floor?.location} - {floor?.floor_no}</Typography>
                        <div>
                            {document.fullscreenEnabled &&
                                <ToolTipIcon
                                    title="FullScreen"
                                    ariaLabel="full-screen"
                                    color="primary"
                                    icon={ <CropFreeIcon fontSize="large" /> }
                                    onClick={() => {
                                        if (!handle.active) {
                                            handle.enter()
                                        } else {
                                            handle.exit()
                                        }
                                    }}
                                />}
                            <ToolTipIcon
                                title="Zoom In"
                                ariaLabel="zoomin"
                                color="primary"
                                icon={ <ZoomInIcon fontSize="large" /> }
                                onClick={() => { setScale((prevScale) => Math.min(prevScale + 0.2, 15)) }}                                                               
                            />
                            <ToolTipIcon
                                title="Zoom Out"
                                ariaLabel="zoomout"
                                color="primary"
                                icon={ <ZoomOutIcon fontSize="large" /> }
                                onClick={() => { setScale((prevScale) => Math.max(prevScale - 0.2, 1)) }}
                            />
                        </div>
                    </>
                }>
                    <FullScreen handle={handle} onChange={setFullScreen} >
                        <div style={{ overflow: 'auto', textAlign: 'center' }}>
                            <div style={{
                                transition: 'transform 0.3s ease-in-out', // Smooth zoom effect
                                transformOrigin: 'top center',
                                display: 'inline-block',
                                textAlign: 'center'
                            }}>
                                <Canvas
                                    floor={floor}
                                    scale={scale}
                                    slotDetails={true}
                                    fullScreen={fullScreen}
                                    getCameraFeed={getCameraFeed}
                                />
                            </div>
                        </div>
                    </FullScreen>
                </CardBox>
            </div>
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
            <SlotBookings open={open} onClose={() => setOpen(false)} initiateMarkings={initiateMarkings} streamUrl={streamUrl} completeMarkings={completeMarkings}/>
        </>
    )
}
export default ParkingSlotMap;